module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-contact-banner'), _vm._v(" "), _c('div', {
    staticClass: "wp980"
  }, [_c('home-contact-content', {
    attrs: {
      "mapurl": _vm.mapurl,
      "location": "北京总部",
      "detail": "全国服务热线：400-168-6606 (工作日9:00-18:00)\n公司总机：010‐62961889   010-62961690\n公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wp980"
  }, [_c('home-contact-content', {
    attrs: {
      "location": "天津分公司",
      "detail": "全国服务热线：400-168-6606 (工作日9:00-18:00)\n公司总机：010‐62961889   010-62961690\n公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
    }
  }), _vm._v(" "), _c('home-contact-content', {
    attrs: {
      "location": "满洲里",
      "detail": "全国服务热线：400-168-6606 (工作日9:00-18:00)\n公司总机：010‐62961889   010-62961690\n公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
    }
  }), _vm._v(" "), _c('home-contact-content', {
    attrs: {
      "location": "二连浩特",
      "detail": "全国服务热线：400-168-6606 (工作日9:00-18:00)\n公司总机：010‐62961889   010-62961690\n公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapPic"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/contact/map-beijing.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20088a6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/contact/HomeContact.vue
// module id = 140
// module chunks = 1